import React, { useRef, useEffect, useState, useCallback } from 'react';
import '../styles/stickyScrollbar.css';

const StickyScrollbar = ({ children }) => {
    const containerRef = useRef(null);
    const proxyRef = useRef(null);
    const innerRef = useRef(null);
    const syncingRef = useRef(false);
    const [hasOverflow, setHasOverflow] = useState(false);

    const syncProxyWidth = useCallback(() => {
        const container = containerRef.current;
        const inner = innerRef.current;
        if (!container || !inner) return;

        const scrollW = container.scrollWidth;
        inner.style.width = scrollW + 'px';
        setHasOverflow(scrollW > container.clientWidth + 1);
    }, []);

    useEffect(() => {
        const container = containerRef.current;
        const proxy = proxyRef.current;
        if (!container || !proxy) return;

        const onContainerScroll = () => {
            if (syncingRef.current) return;
            syncingRef.current = true;
            proxy.scrollLeft = container.scrollLeft;
            syncingRef.current = false;
        };

        const onProxyScroll = () => {
            if (syncingRef.current) return;
            syncingRef.current = true;
            container.scrollLeft = proxy.scrollLeft;
            syncingRef.current = false;
        };

        container.addEventListener('scroll', onContainerScroll);
        proxy.addEventListener('scroll', onProxyScroll);

        // Observe size changes on the container and any table inside it
        const resizeObserver = new ResizeObserver(syncProxyWidth);
        resizeObserver.observe(container);
        const table = container.querySelector('table');
        if (table) {
            resizeObserver.observe(table);
        }

        // Initial sync
        syncProxyWidth();

        return () => {
            container.removeEventListener('scroll', onContainerScroll);
            proxy.removeEventListener('scroll', onProxyScroll);
            resizeObserver.disconnect();
        };
    }, [syncProxyWidth]);

    return (
        <div className="sticky-scroll-wrapper">
            <div className="sticky-scroll-container" ref={containerRef}>
                {children}
            </div>
            <div className={`sticky-scrollbar-track${hasOverflow ? '' : ' sticky-scrollbar-hidden'}`}>
                <div className="sticky-scrollbar-proxy" ref={proxyRef}>
                    <div className="sticky-scrollbar-inner" ref={innerRef} />
                </div>
            </div>
        </div>
    );
};

export default StickyScrollbar;
